import apiUrl from '@/apis/api';
import { postWithAuth } from '@/lib/httpAdapter';

export interface HandleRoleChangeSeatManagementRequest {
  organizationUUID: string;
  userUUID: string;
  oldRole: string;
  newRole: string;
}

export interface HandleRoleChangeSeatManagementResponse {
  success: boolean;
  message: string;
  requiresPayment: boolean;
  checkoutUrl?: string;
}

export const handleRoleChangeSeatManagement = async (
  request: HandleRoleChangeSeatManagementRequest
): Promise<HandleRoleChangeSeatManagementResponse> => {
  const response = await postWithAuth(
    `${apiUrl}billing/handleRoleChangeSeatManagement`,
    request
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.error || 'Failed to handle role change seat management'
    );
  }

  return response.json();
};
